import { SaleStatusEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, OneToMany, OneToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StoreConsumption } from "../store-consumption/entity/store-consumption.entity";

@Entity("store_return")

export class StoreReturn {

    @PrimaryGeneratedColumn("increment", { name: 'store_return_id' })
    storeReturnId: number;
    
    @Column({
        nullable: false,
        name: "store_return_date"
    })
    storeReturnDate: Date;
    @Column("int", {
        nullable: false,
        name: "sale_order_id"
    })
    saleOrderId: number;
    @Column("int", {
        nullable: false,
        name: "item_category_id"
    })
    itemCategoryId: number;
    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;
    @Column("varchar", {
        nullable: false,
        name: "store_return_no"
    })
    storeReturnNo: string;
    
    @Column("int", {
        nullable: true,
        name: "store_consumption_id",
        default:0
    })
    storeConsumptionId: number;

    @Column("boolean", {
        nullable: false,
        name: "is_damaged",
        default:0
    })
    isDamaged: number;

    @Column("varchar", {
        nullable: false,
        name: "return_reason"
    })
    returnReason: string;
    
    @Column("int", {
        nullable: false,
        name: "return_quantity"
    })
    returnQuantity: number;

    @Column("int", {
        nullable: false,
        name: "unit_id"
    })
    unitId: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "remarks"
    })
    remarks: string;
    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "approvar"
    })
    approvar: string;

    @Column("varchar", {
        nullable: false,
        name: "status",
        default: StatusEnum.OPEN,
        length: 30
      })
      status: string;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: false,
        name: "created_user",
        default:"ADMIN",
        length:50
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
   
}

